import { trackEditCandidateDetailsClickedEvent } from '../../../utils/events/addCandidateEvents';
import FormStep from './FormStep';
import { TextField } from 'braid-design-system';
import EmailSection from './EmailSection';
import { ADD_CANDIDATE_FORM_FIELD_NAMES } from './AddCandidateForm';
import translations from './.vocab/';
import { useTranslations } from '@vocab/react';

interface Props {
  email: any;
  editable: boolean;
  showEditButton: boolean;
  onEditEmail: () => void;
}
const StepOne = ({ email, editable, showEditButton, onEditEmail }: Props) => {
  const { t } = useTranslations(translations);
  return editable ? (
    <FormStep
      editable
      onEditClickTracking={trackEditCandidateDetailsClickedEvent}
    >
      <>
        <TextField
          id={ADD_CANDIDATE_FORM_FIELD_NAMES.EMAIL}
          label={t('Email address')}
          value={email.value}
          tone={email.valid ? 'neutral' : 'critical'}
          onChange={email.onChange}
          onBlur={email.onBlur}
          message={!email.valid && email.errorMessage}
          reserveMessageSpace
          placeholder={t('Enter email address')}
          type="email"
        />
      </>
    </FormStep>
  ) : (
    <EmailSection
      email={email}
      showEditButton={showEditButton}
      onEditEmail={onEditEmail}
    />
  );
};

export default StepOne;
